(function () {

  'use strict';

  function pxAuthenticationContextMenu(
    $timeout, $window
    ) {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        selectedTab: '=selectedTab',
        contextPosition: '=contextPosition',
        resource: '=resource',
        callback: '&callback',
        callbackItem: '&callbackItem'
      },
      // TEMPLATE USAGE -> px-authentication-context-menu // 1 USAGE THIS IS APPROVED
      templateUrl: 'app/components/authenticationSettings/_authenticationContextMenu/authenticationContextMenu.template.html',
      link: function (scope, element, attrs) {

        (function() {
          initContexContent();
        })();

        scope.$watch(function() {
          return scope.contextPosition;
        }, function(oldVal, newVal){
          if (oldVal !== newVal) {
            initContexContent();
          }
        })

        function initContexContent() {
          checkValidPostion (scope.contextPosition.left, scope.contextPosition.top) 
        };

        function checkValidPostion (left, top) {
          var offsetX = 60;
          var offsetY = 100;
          
          left = left - offsetX;
          var containerWidth = angular.element('.container').innerWidth();

          $timeout(function() {
            var menuHeight = angular.element('.context-content-container').innerHeight();
            var menuWidth = angular.element('.context-content-container').innerWidth();

            var screenVertCenter = $window.innerHeight / 2;
            var menuVerticalCenter = menuHeight / 2;
            top = screenVertCenter - menuVerticalCenter;

            var screenHorCenter = window.innerWidth / 2
            var menuHorizontalCenter = menuWidth / 2;

            left = screenHorCenter - menuHorizontalCenter; 

            angular.element('.context-content-container').css({left: left , top: top});
            angular.element('.context-content-container').css({display: 'block'});
          }, 50)
        }

        scope.closePopup = function (item) {
          scope.callback({selectedContextMenuItem: null, contextPosition: null, contextContent: null});
          if (item) {
            scope.callbackItem({callbackItem: item})
          }

        }

        scope.clickOutside = function (bypass) {
          if (!bypass) {
            scope.callback({selectedContextMenuItem: null, contextPosition: null, contextContent: null});
          }
        }

        scope.$on('$destroy', function() {
          angular.element('.context-content-container').css({display: 'none'});
        });

      }
    }
  }



  pxAuthenticationContextMenu.$inject = ['$timeout', '$window'];

  angular
    .module('printix-admin')
    .directive('pxAuthenticationContextMenu', pxAuthenticationContextMenu);

})();